import React, { useMemo } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const ResponseTimeChart = ({ logs }) => {
  const chartData = useMemo(() => (
    logs
      .filter(log => log.is_success && log.response_time_ms != null)
      .slice() // avoid mutating original
      .reverse()
      .map(log => ({
        time: new Date(log.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        responseTime: log.response_time_ms,
        fullTimestamp: new Date(log.timestamp).toLocaleString(),
      }))
  ), [logs]);

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center h-[300px] text-gray-400">
        <p>No response time data available for the last 24 hours</p>
      </div>
    );
  }

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
      return (
        <div className="bg-[#1e293b] border border-[#334155] rounded-lg p-3 shadow-lg">
          <p className="text-white text-sm font-semibold mb-1">{payload[0].payload.fullTimestamp}</p>
          <p className="text-[#3599B8] text-sm">Response Time: {payload[0].value}ms</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#ffffff20" />
        <XAxis dataKey="time" stroke="#94a3b8" style={{ fontSize: '12px' }} tick={{ fill: '#94a3b8' }} />
        <YAxis
          stroke="#94a3b8"
          style={{ fontSize: '12px' }}
          tick={{ fill: '#94a3b8' }}
          label={{ value: 'Response Time (ms)', angle: -90, position: 'insideLeft', style: { fill: '#94a3b8', fontSize: '12px' } }}
        />
        <Tooltip content={<CustomTooltip />} />
        <Line
          type="monotone"
          dataKey="responseTime"
          stroke="#3599B8"
          strokeWidth={2}
          dot={{ fill: '#3599B8', r: 3 }}
          activeDot={{ r: 5, fill: '#2C9C7A' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ResponseTimeChart;
